export const colunas = [
  {
    title: '#',
    dataIndex: 'BotijaoId',
    key: 'BotijaoId',
    width: 76
  },
  {
    title: 'Nome',
    dataIndex: 'Nome',
    key: 'Nome'
  },
]